<script setup lang="ts">


useSeoMeta({
  title: "Planer",
  ogTitle: "Planer"
})
</script>
<template>
  <h1>Planner</h1>
</template>
